type MigrationPromptModal = HTMLElement & {
  hidden: boolean;
};

export interface MigrationPromptContext {
  readonly email?: string;
  readonly legacyAmount?: string;
}

export function openMigrationModal(context: MigrationPromptContext = {}): boolean {
  const modal = document.getElementById('pif-migration-prompt-modal') as MigrationPromptModal | null;
  if (!modal) {
    return false;
  }

  if (context.email) {
    const migrateBtn = modal.querySelector<HTMLAnchorElement>('#pif-migration-prompt-migrate-btn');
    if (migrateBtn) {
      try {
        const baseHref = migrateBtn.dataset['baseHref'] || migrateBtn.href;
        if (!migrateBtn.dataset['baseHref']) {
          migrateBtn.dataset['baseHref'] = baseHref;
        }
        const url = new URL(baseHref);
        url.searchParams.set('email', context.email);

        if (context.legacyAmount) {
          url.searchParams.set('legacy_amount', context.legacyAmount);
        }

        url.searchParams.set('hint', 'migration');
        migrateBtn.href = url.toString();
      } catch {
        // no-op
      }
    }
  }

  modal.hidden = false;
  const dialog = modal.querySelector<HTMLElement>('.c-modal__dialog');
  if (dialog) {
    dialog.setAttribute('tabindex', '-1');
    dialog.focus();
  }
  document.body.style.overflow = 'hidden';
  return true;
}

export function closeMigrationModal(): void {
  const modal = document.getElementById('pif-migration-prompt-modal') as MigrationPromptModal | null;
  if (!modal) {
    return;
  }

  modal.hidden = true;
  document.body.style.overflow = '';
}

export function bindMigrationPrompt(): void {
  const modal = document.getElementById('pif-migration-prompt-modal') as MigrationPromptModal | null;
  if (!modal) {
    return;
  }

  modal.addEventListener('click', (event: MouseEvent) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) {
      return;
    }

    if (target.dataset['close']) {
      event.preventDefault();
      closeMigrationModal();
    }
  });

  const remindBtn = modal.querySelector<HTMLButtonElement>('#pif-migration-prompt-remind-btn');
  if (remindBtn) {
    remindBtn.addEventListener('click', (event: MouseEvent) => {
      event.preventDefault();
      closeMigrationModal();
      try {
        localStorage.setItem('pifster_migration_prompt_last', String(Date.now()));
      } catch {
        // no-op
      }
    });
  }
}
